<template>
  <div>
    <v-card>
      <v-card-title> Reminder List {{ entitySheetId }}</v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="7">
              <v-btn
                color="primary"
                dark
                class="mb-2 mr-2"
                @click="handleNewReminder"
              >
                New reminder
              </v-btn>
            </v-col>
          </v-row>
          <RemindersFilter :filters="filters" @update:filters="filters = $event"></RemindersFilter>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-data-table
                :headers="headers"
                :items="computedItemCollection"
                @click:row="openEntityListDialog"
                :footer-props="{
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus'
                }"
              >
                <template v-slot:top>
                  <v-toolbar flat>
                    <v-spacer></v-spacer>
                    <v-dialog v-model="dialogDelete" max-width="500px">
                      <v-card>
                        <v-card-title class="headline"
                          >Are you sure you want to delete this
                          item?</v-card-title
                        >
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="blue darken-1" text @click="closeDelete"
                            >Cancel</v-btn
                          >
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="deleteItemConfirm"
                            >OK</v-btn
                          >
                          <v-spacer></v-spacer>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                </template>
                <template v-slot:item.min_quantity="{item}">
                  {{ item.min_quantity }} DB
                </template>
                <template v-slot:item.current_stock="{item}">
                  <span v-if="item.current_stock != 0 && item.current_stock_quantity != 0">
                    {{ item.current_stock }} DB - [ {{ item.current_stock_quantity }} {{ item.def_quantity }} ]
                  </span>
                  <span v-else>
                    Out of stock
                  </span>
                </template>
                <template v-slot:item.is_active="{item}">
                    {{ item.is_active === true ? 'Active' : 'Inactive'}}
                </template>
                <template v-slot:item.actions="{item}">
                  <v-icon
                    v-if="permissionCan('delete')"
                    small
                    @click.stop="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
          <div v-if="reminderModalData.dialog">
            <ReminderModalForm
              :modalData="reminderModalData"
              :permissions="permissions"
              @closeModalForm="handleCloseReminderModalForm"
              @saveModalForm="handleSaveReminderModalForm"
              @new="handleNewReminder"
            ></ReminderModalForm>
          </div>

          <v-row justify="center">
            <EntitySheetDialog
              :entitySheetId="entitySheetId"
              :entityDialog="entityDialog"
              @handleCloseEntitySheetDialog="handleCloseEntitySheetDialog"
            >
            </EntitySheetDialog>
          </v-row>

          <v-row justify="center">
            <v-dialog
              v-model="dialogEntityList"
              persistent
              width="1440px"
              scrollable
            >
              <v-card>
                <v-card-title>
                  <v-col cols="12" sm="12" md="12">
                    <span class="text-h5" v-if="selectedStockList"
                      >{{ selectedStockList.reference }} -
                      {{ selectedStockList.name }}</span
                    >
                    <v-btn
                      @click="dialogEntityList = false"
                      style="float: right; cursor: pointer"
                      icon
                      color="#26223c"
                    >
                      <v-icon> mdi-close</v-icon>
                    </v-btn>
                  </v-col>
            <v-col cols="12" sm="2" md="2">
              <v-btn
                depressed
                color="primary"
                class="ma-2"
               v-if="selectedStockList" @click.prevent="goToItemPage" 
              >
                Edit Item
              </v-btn>
            </v-col>
                </v-card-title>
            
                <v-card-text>

                  <v-tabs
                    v-model="tab"
                    background-color="#232341"
                    centered
                    dark
                    icons-and-text
                  >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-1">
                      Entity list
                      <v-icon>mdi-chart-line</v-icon>
                    </v-tab>
                    <v-tab href="#tab-2">
                      Stock forecast
                      <v-icon>mdi-playlist-check</v-icon>
                    </v-tab>
                     
                  </v-tabs>
                  <v-tabs-items v-model="tab">
                    <v-tab-item :key="1" :value="'tab-1'">
                      <v-card flat>
                        <v-card-text>
                          <v-row>
                            <v-col cols="4" sm="3" md="2">
                              <v-checkbox
                                v-model="listFiltersInModal.onHand"
                                label="On hand"
                                @change="calculateEntityList"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="4" sm="3" md="2">
                              <v-checkbox
                                v-model="listFiltersInModal.damaged"
                                label="Damaged"
                                @change="calculateEntityList"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="4" sm="3" md="2">
                              <v-checkbox
                                v-model="listFiltersInModal.remainder"
                                label="Remainder"
                                @change="calculateEntityList"
                              ></v-checkbox>
                            </v-col>
                            <v-col cols="6" sm="3" md="2">
                              <v-select
                                v-model="listFiltersInModal.storage"
                                :items="computedStorages"
                                item-text="name"
                                label="Select storage"
                                return-object
                                @change="calculateEntityList"
                              >
                              </v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-data-table
                                :headers="entityListHeaders"
                                :items="entityList"
                                class="elevation-1"
                                group-by="quantity"
                                show-group-by
                                :items-per-page="5"
                                @click:row="handleOpenEntitySheetDialog"
                                :footer-props="{
                                  showFirstLastPage: true,
                                  firstIcon: 'mdi-arrow-collapse-left',
                                  lastIcon: 'mdi-arrow-collapse-right',
                                  prevIcon: 'mdi-minus',
                                  nextIcon: 'mdi-plus',
                                  itemsPerPageOptions: [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, -1]
                                }"
                              >
                                <template
                                  v-slot:group.header="{
                                    group,
                                    headers,
                                    toggle,
                                    isOpen,
                                    items,
                                  }"
                                >
                                  <td :colspan="headers.length">
                                    <v-btn
                                      @click="toggle"
                                      small
                                      icon
                                      :ref="group"
                                      :data-open="isOpen"
                                    >
                                      <v-icon v-if="isOpen"
                                        >mdi-chevron-up</v-icon
                                      >
                                      <v-icon v-else>mdi-chevron-down</v-icon>
                                    </v-btn>
                                    {{ selectedStockList.reference }}
                                    {{ selectedStockList.name }} - {{ group
                                    }}{{ selectedStockList.quantityUnit }} -
                                    {{ items.length }} pcs
                                  </td>
                                </template>
                                <template v-slot:item.quantityUnit="{ item }">
                                  <span>
                                    {{ item.quantity }}
                                    {{ selectedStockList.quantityUnit }}</span
                                  >
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                    <v-tab-item :key="2" :value="'tab-2'">
                      <v-card flat>
                        <v-card-text>
                          <v-row>
                            <v-col cols="12" sm="12" md="12" v-if="showChart">
                              <VueApexCharts
                                height="350"
                                :options="chartOptions"
                                :series="series"
                              ></VueApexCharts>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-data-table
                                :headers="forecastListHeaders"
                                :items="forecastList"
                                class="elevation-1"
                              >
                                <template #header="{ props: { headers } }">
                                  <thead class="v-data-table-header">
                                    <tr>
                                      <th></th>
                                      <th></th>
                                      <th></th>
                                      <th style="max-width: 100px">
                                        <v-select
                                          v-model="typeFilter"
                                          :items="['Select', ...typeCollection]"
                                          item-text="salesPersonName"
                                          item-value="salesPersonName"
                                        ></v-select>
                                      </th>
                                      <th></th>
                                      <th></th>
                                      <th></th>
                                      <th></th>
                                      <th></th>
                                    </tr>
                                  </thead>
                                </template>
                                <template v-slot:item.name="{ item }">
                                  <span>{{ selectedStockList.name }}</span>
                                </template>
                                <template
                                  v-slot:item.transaction_number="{ item }"
                                >
                                  <router-link
                                    :to="
                                      urls[
                                        item.transaction_type.replaceAll(
                                          '\\',
                                          ''
                                        )
                                      ] + item.transaction_id
                                    "
                                    target="_blank"
                                  >
                                    {{ item.transaction_number }}
                                  </router-link>
                                </template>
                                <template v-slot:item.quantity="{ item }">
                                  <span>
                                    {{ item.quantity }}
                                    {{ selectedStockList.quantityUnit }}</span
                                  >
                                </template>
                              </v-data-table>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-tab-item>
                  </v-tabs-items>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="dialogEntityList = false"
                  >
                    Close
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>
<style>
  .row:has(input[type='checkbox']) label{
    margin-bottom: 0 !important;
  }
</style>

<script>
import { mapGetters, mapActions } from "vuex";

import ApiService from "@/core/services/api.service";

import ReminderModalForm from "../reminder/ReminderModalForm";

import EntitySheetDialog from "@/view/components/EntitySheetDialog";

import VueApexCharts from "vue-apexcharts";

import { URL } from "@/view/components/EntitySheetDialog";
import RemindersFilter from "./components/RemindersFilter.vue";

//import Swal from "sweetalert2";

export const ENDPOINT = "stock/reminders/";
export const REM_ENDPOINT = "stock/reminder/";

const initialListFilters = {
  active: false,
};

export default {
  name: "Reminders",
  components: {
    VueApexCharts,
    ReminderModalForm,
    EntitySheetDialog,
    RemindersFilter,
  },
  data() {
    return {
      loader: false,
      urls: URL,
      tab: null,
      showAll: false,
      filters: {
        active: true,
        search: "",
        below_threshold: null,
        repeatdays: [],
        last_notified_at: null,
      },
      permissions: [],
      reminders: [],
      loaing: false,
      error: null,
      headers: [
        {
          text: "ID",
          value: "id",
        },
        /*{
          text: "Item ID",
          value: "item_id",
        },*/
        {
          text: "Reference",
          value: "item.reference",
        },
        {
          text: "Name",
          value: "translation.name",
        },
        {
          text: "Stock",
          value: "current_stock",
        },
        {
          text: "Threshold",
          value: "min_quantity",
        },
        {
          text: "Repeat Every Days",
          value: "repeat_every_days",
        },
        {
          text: "Status",
          value: "is_active",
        },
        {
          text: "Actions",
          value: "actions",
        },
      ],

      entityListHeaders: [
        {
          text: "Entity ID",
          value: "item_entity_id",
          groupable: false,
        },
        {
          text: "Created at",
          value: "created_at",
          groupable: false,
        },
        {
          text: "Item name",
          value: "name",
          groupable: false,
        },
        {
          text: "Quantity",
          value: "quantity",
        },
        {
          text: "Quantity unit",
          value: "quantityUnit",
          groupable: false,
        },
        {
          text: "State",
          value: "state",
          groupable: false,
        },
        {
          text: "Storage",
          value: "storage",
          groupable: false,
        },
      ],

      forecastListHeaders: [
        {
          text: "Scheduled date",
          value: "scheduled_date",
        },
        {
          text: "Reference",
          value: "reference_number",
        },
        {
          text: "Item name",
          value: "name",
        },
        {
          text: "Transaction number",
          value: "transaction_number",
        },
        {
          text: "Transaction type",
          value: "transactionType",
          filter: (value) => {
            if (this.typeFilter == "Select") return true;
            return value == this.typeFilter;
          },
        },
        {
          text: "Quantity",
          value: "quantity",
        },
        {
          text: "Storage",
          value: "storage",
        },
        {
          text: "Linked entity",
          value: "item_entity_id",
        },
        {
          text: "Parent ID",
          value: "parent_item_entity_id",
        },
      ],

      modalData: {
        dialog: false,
        editedId: null,
      },

      reminderModalData: {
        dialog: false,
        editedId: null,
      },

      listFilters: Object.assign({}, initialListFilters),
      listFiltersInModal: Object.assign({}, initialListFilters),

      storages: [],
      dialogDelete: false,
      dialogEntityList: false,
      selectedStockList: null,
      selectedItem: null,
      entityList: [],
      forecastList: [],
      typeFilter: "Select",
      series: null,
      entitySheetId: null,
      entityDialog: false,

      /*showChart: false,
      chartOptions: {
        colors: ["#26223c"],
        chart: {
          height: 350,
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "stepline",
        },
        markers: {
          size: 5,
        },
        title: {
          text: "",
          align: "left",
          style: {
            fontSize: "14px",
          },
        },
        xaxis: {
          type: "date",
          axisBorder: {
            show: true,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          tickAmount: 4,
          floating: false,

          labels: {
            // style: {
            //   colors: '#000000',
            // },
            offsetY: -7,
            offsetX: 0,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        fill: {
          colors: "#26223c",
          // opacity: 0.9
        },
        tooltip: {
          x: {
            show: false,
            format: "yyyy-MM-dd",
          },
          fixed: {
            enabled: false,
            position: "topRight",
          },
        },
        grid: {
          yaxis: {
            lines: {
              offsetX: -30,
            },
          },
          padding: {
            left: 20,
          },
        },
      },*/
    };
  },

  computed: {
    ...mapGetters([
      "stockItemModCollection",
      "stockItemCollection",
    ]),

    typeCollection() {
      return this.forecastList.map((item) => {
        return item.transactionType;
      });
    },

    computedItemCollection() {
      const s = (this.filters.search || "").toLowerCase().trim();
      const selected = this.filters.repeatdays;
      let below_thresh = this.filters.below_threshold;

      return this.reminders.filter(r => {
        let ok = true;
      
        if (s) {
          const name = (r.translation && r.translation.name) ? r.translation.name : "";
          ok = ok && (
            String(r.id).toLowerCase().includes(s) ||
            (r.reference || "").toLowerCase().includes(s) ||
            name.toLowerCase().includes(s) ||
            (r.note || "").toLowerCase().includes(s)
          );
        }
      
        if (this.filters.active !== null && this.filters.active !== undefined) {
          ok = ok && (Number(r.is_active) === Number(this.filters.active));
        }

        if(this.filters.below_threshold === 0){
          below_thresh = null;
        }else if(this.filters.below_threshold === 1){
          below_thresh = true;
        }else if(this.filters.below_threshold === 2){
          below_thresh = false;
        }
      
        if (below_thresh !== null && below_thresh !== undefined) {
          ok = ok && (Number(r.is_below_threshold) === Number(below_thresh));
        }

        if(Array.isArray(selected) && selected.length > 0){
          ok = ok && (selected.includes(Number(r.repeat_every_days)));
        }

        if(this.filters.last_notified_at !== null && this.filters.last_notified_at !== undefined){
          ok = ok && (String(this.filters.last_notified_at) === String(r.last_notified_at).split("T")[0]);
        }
      
        return ok;
      });
    },
  },

  watch: {
    dialogDelete(val) {
      val || this.closeDelete();
    },
    "$route.params.id": {
      handler: function (id) {
        if (id) {
          this.editItem(id);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    ...mapActions([
      "fetchStockItem",
      "fetchStockItemMod",
    ]),

    async fetchReminders(){
        this.loading = true;
        this.error = null;
        
        try{
            const res = await ApiService.get("stock/reminder");
            this.reminders = res.data;
        }catch(e){
            this.error = e;
        }finally {
            this.loading = false;
        }
    },

    goToItemPage() {
      window.open(`#/inventory/items/${this.selectedStockList.id}`, '_blank');
    },

    roundToTwo(num) {
      return +(Math.round(num + "e+2") + "e-2");
    },

    calculateEntityList() {
      return new Promise((resolve) => {
        let computedEntityList = this.stockItemCollection.filter(
          (stockItem) => {
            let isFiltered = true;
            if (
              this.listFiltersInModal.storage.id != stockItem.storage_id &&
              this.listFiltersInModal.storage.id != "All"
            ) {
              isFiltered = false;
            }

            let filterStatusArray = [];

            if (this.listFiltersInModal.onHand) filterStatusArray.push(4);
            if (this.listFiltersInModal.damaged) filterStatusArray.push(9);
            if (this.listFiltersInModal.remainder) filterStatusArray.push(3);

            if (
              filterStatusArray.length > 0 &&
              !filterStatusArray.includes(stockItem.status)
            ) {
              isFiltered = false;
            }

            return isFiltered;
          }
        );

        this.entityList = computedEntityList
          .filter((i) => i.item_id == this.selectedStockList.id)
          .map((i) => {
            let item = this.$store.getters.getStockItemByID(i.item_id);
            i.name = item.name;
            i.state = this.$t("ADJUSTMENT.status_" + i.status);
            i.storage = this.$store.getters.getStorageByID(i.storage_id)
              ? this.$store.getters.getStorageByID(i.storage_id).name
              : "";
            i.quantityUnit = this.$store.getters.getQuantityUnitByID(
              item.quantity_unit_id
            ).name;
            return i;
          });

        resolve();
      });
    },

    openEntityListDialog(selectedItem) {
        this.reminderModalData.editedId = selectedItem.id;
        this.reminderModalData.dialog = true;
    },

    handleNew() {
      this.modalData.editedId = null;
      this.modalData.dialog = true;
    },

    //Reminder Modal
    handleNewReminder() {
      this.reminderModalData.editedId = null;
      this.reminderModalData.dialog = true;
    },

    handleSaveReminderModalForm() {
      this.fetchReminders();
      this.handleCloseReminderModalForm();
    },

    handleCloseReminderModalForm() {
      this.reminderModalData.dialog = false;
      this.reminderModalData.editedId = null;
    },

    handleSaveModalForm() {
      this.handleCloseModalForm();
    },

    handleCloseModalForm() {
      this.series = null;
      this.tab = "tab-1";
      this.entitySheetId = null;
      this.modalData.dialog = false;
      this.fetchStockItem();

      if (this.$route.name !== "stockItems")
        this.$router.push({ name: "stockItems" });
    },

    deleteItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    handleOpenEntitySheetDialog(item) {
      this.entitySheetId = item.item_entity_id;
      this.entityDialog = true;
    },

    handleCloseEntitySheetDialog() {
      this.entityDialog = false;
      this.entitySheetId = null;
    },

    deleteItemConfirm() {
      ApiService.delete(REM_ENDPOINT + this.editedItem.id)
        .then(() => {
          this.fetchReminders();
        })
        .catch((error) => {
          console.log("Error!: ", error);
        });
      this.closeDelete();
    },

    closeDelete() {
      // this.editedItem = Object.assign({}, initialFormData);
      this.modalData.editedId = null;
      this.dialogDelete = false;
    },

    handleClickItem(item) {
      if (this.permissionCan("view") && !this.dialogDelete) {
        this.$router.push(`/stock/reminders/${item.id}`);
      }
    },

    permissionCan(action) {
      return this.permissions.find(
        (x) => x.name == "stock.reminder." + action
      );
    },

    setPermissions() {
      if (localStorage.permissions) {
        this.permissions = JSON.parse(localStorage.permissions).filter(
          (item) => item.name.indexOf("stock") > -1
        );
      }
    },
  },

  async mounted() {
    this.fetchStockItem();
    this.fetchStockItemMod();
    this.setPermissions();
    this.fetchReminders();
  },
};
</script>
